"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchPreviewMobile = void 0;
var _components = require("@ori-ui/components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _navigation = require("../../context/navigation");
var _useTranslations = require("../../hooks/useTranslations");
var _models = require("../../models");
var _utils = require("../../utils");
var _ProductsSection = require("./components/ProductsSection");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const SearchPreviewMobile = () => {
  const {
    results,
    debouncedValue: query,
    mode,
    popularData,
    searchHistory
  } = (0, _navigation.useSearchInput)();
  const {
    brands = [],
    categories = [],
    numberOfProducts,
    products = [],
    suggestions = []
  } = results ?? {};
  const {
    popularProducts = [],
    popularSearchQueries = []
  } = popularData;
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    formatMessage,
    translations
  } = (0, _useTranslations.useTranslations)();
  const hasSearchHistory = searchHistory.items.length > 0;
  const {
    clearHistory,
    items
  } = searchHistory;
  const addSuggestionToHistory = (0, _react.useCallback)((suggestion, _, url) => {
    searchHistory.addSearchItem(suggestion, url);
  }, [searchHistory]);
  const recentSearchesHeader = (0, _react.useMemo)(() => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.RecentSearchesHeader, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SectionLabel, {
      variant: "caption",
      children: translations.recentSearches
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
      variant: "text",
      size: "small",
      onClick: clearHistory,
      children: translations.clear
    })]
  }), [clearHistory, translations.clear, translations.recentSearches]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_constants.SEARCH_PREVIEW),
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Inner, {
      children: [mode === _models.SearchPreviewMode.Results ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledQueryListSection, {
        title: translations.suggestions,
        items: suggestions,
        query: query,
        queryType: "label",
        onQueryClick: addSuggestionToHistory
      }) : hasSearchHistory ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledQueryListSection, {
        title: recentSearchesHeader,
        items: items,
        query: query,
        queryType: "label"
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledQueryListSection, {
        title: translations.popularSearches,
        items: popularSearchQueries,
        query: query,
        queryType: "label",
        onQueryClick: addSuggestionToHistory
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProductsSection.ProductsSection, {
        products: mode === _models.SearchPreviewMode.Popular ? popularProducts : products,
        query: query,
        viewAllLink: mode === _models.SearchPreviewMode.Popular ? _constants.BESTSELLERS_PATH : (0, _utils.getSearchUrl)(query),
        title: mode === _models.SearchPreviewMode.Results ? formatMessage('productsX', {
          count: numberOfProducts
        }) : translations.popularProducts
      }), mode === _models.SearchPreviewMode.Results ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledQueryListSection, {
          title: translations.brands,
          items: brands,
          showIcon: false,
          query: query,
          onQueryClick: addSuggestionToHistory
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledQueryListSection, {
          title: translations.categories,
          items: categories,
          showIcon: false,
          query: query,
          onQueryClick: addSuggestionToHistory
        })]
      }) : null]
    })
  });
};
exports.SearchPreviewMobile = SearchPreviewMobile;
